// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json = require("./Json.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var LogIO = require("./LogIO.bs.js");
var Luxon = require("luxon");
var BigJs = require("big.js");
var FloatSafe = require("./FloatSafe.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var TypeUtils = require("./types/TypeUtils.bs.js");
var Relude_Int = require("relude/src/Relude_Int.bs.js");
var Relude_Map = require("relude/src/Relude_Map.bs.js");
var Relude_Set = require("relude/src/Relude_Set.bs.js");
var Caml_format = require("bs-platform/lib/js/caml_format.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var StringUtils = require("./StringUtils.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Float = require("relude/src/Relude_Float.bs.js");
var Relude_Tuple = require("relude/src/Relude_Tuple.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var Duration$BsLuxon = require("bs-luxon/src/Duration.bs.js");
var CommonTypes_Timezone = require("./types/CommonTypes_Timezone.bs.js");
var Relude_Extensions_Ord = require("relude/src/extensions/Relude_Extensions_Ord.bs.js");
var IndexJs = require("date-fns/fp/endOfDay/index.js");
var IndexJs$1 = require("date-fns/fp/endOfHour/index.js");
var IndexJs$2 = require("date-fns/fp/endOfWeek/index.js");
var IndexJs$3 = require("date-fns/fp/endOfYear/index.js");
var IndexJs$4 = require("date-fns/fp/endOfMonth/index.js");
var IndexJs$5 = require("date-fns/fp/startOfDay/index.js");
var IndexJs$6 = require("date-fns/fp/endOfMinute/index.js");
var IndexJs$7 = require("date-fns/fp/endOfSecond/index.js");
var IndexJs$8 = require("date-fns/fp/startOfHour/index.js");
var IndexJs$9 = require("date-fns/fp/startOfWeek/index.js");
var IndexJs$10 = require("date-fns/fp/startOfYear/index.js");
var IndexJs$11 = require("date-fns/fp/startOfMonth/index.js");
var IndexJs$12 = require("date-fns/fp/startOfMinute/index.js");
var IndexJs$13 = require("date-fns/fp/startOfSecond/index.js");

function make(prim, prim$1, prim$2, prim$3, prim$4, prim$5, prim$6, prim$7) {
  var tmp = {};
  if (prim !== undefined) {
    tmp.month = Caml_option.valFromOption(prim);
  }
  if (prim$1 !== undefined) {
    tmp.day = Caml_option.valFromOption(prim$1);
  }
  if (prim$2 !== undefined) {
    tmp.year = Caml_option.valFromOption(prim$2);
  }
  if (prim$3 !== undefined) {
    tmp.hour = Caml_option.valFromOption(prim$3);
  }
  if (prim$4 !== undefined) {
    tmp.minute = Caml_option.valFromOption(prim$4);
  }
  if (prim$5 !== undefined) {
    tmp.second = Caml_option.valFromOption(prim$5);
  }
  if (prim$6 !== undefined) {
    tmp.millisecond = Caml_option.valFromOption(prim$6);
  }
  return tmp;
}

function toRecord(parts) {
  return {
          month: Caml_option.undefined_to_opt(parts.month),
          day: Caml_option.undefined_to_opt(parts.day),
          year: Caml_option.undefined_to_opt(parts.year),
          hour: Caml_option.undefined_to_opt(parts.hour),
          minute: Caml_option.undefined_to_opt(parts.minute),
          second: Caml_option.undefined_to_opt(parts.second),
          millisecond: Caml_option.undefined_to_opt(parts.millisecond)
        };
}

var DateParts = {
  make: make,
  toRecord: toRecord
};

function set(param, param$1) {
  return Relude_Globals.flip((function (prim, prim$1) {
                return prim.set(prim$1);
              }), param, param$1);
}

function timezone(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great((function (prim) {
                              return prim.zoneName;
                            }), CommonTypes_Timezone.fromString, param);
              }), Relude_Option.getOrThrow, param);
}

var DateTime = {
  set: set,
  timezone: timezone
};

function getIntervalPart(interval, t) {
  return Relude_Int.fromFloat(Relude_Float.floor(t.as(interval)));
}

var Duration = {
  getIntervalPart: getIntervalPart
};

var Luxon$1 = {
  DateParts: DateParts,
  DateTime: DateTime,
  Duration: Duration
};

function cloneJsDateToPreventMutation(param) {
  return Relude_Globals.$great$great((function (prim) {
                return prim.toISOString();
              }), (function (prim) {
                return new Date(prim);
              }), param);
}

function fromString(param) {
  return Relude_Globals.$great$great((function (prim) {
                return prim;
              }), Json.Decode.$$Option.date, param);
}

function getLuxonDate(param) {
  return Relude_Globals.$great$great((function (prim) {
                return prim.getTime();
              }), (function (prim) {
                return Luxon.DateTime.fromMillis(prim);
              }), param);
}

function getLuxonNow(param) {
  return Relude_Globals.$great$great((function (prim) {
                return new Date();
              }), getLuxonDate, param);
}

function getLocalTimezone(param) {
  return Relude_Globals.$great$great(getLuxonNow, timezone, param);
}

function formatLuxonDate(fmt) {
  if (typeof fmt === "number") {
    switch (fmt) {
      case /* ISO */0 :
          return function (param) {
            return param.toISO();
          };
      case /* Date */1 :
          return function (param) {
            return param.toFormat("yyyy-LL-dd");
          };
      case /* DateKey */2 :
          return function (param) {
            return param.toFormat("yyyyLLdd");
          };
      case /* LongMonthAndDay */3 :
          return function (param) {
            return param.toFormat("LLLL d");
          };
      case /* ShortMonthAndDay */4 :
          return function (param) {
            return param.toFormat("LLL d");
          };
      case /* WeekdayShortName */5 :
          return function (param) {
            return param.toFormat("ccc");
          };
      case /* WeekdayLongName */6 :
          return function (param) {
            return param.toFormat("cccc");
          };
      case /* ShortDate */7 :
          return function (param) {
            return param.toFormat("ccc LLL d");
          };
      case /* ShortDateCompact */8 :
          return function (param) {
            return param.toFormat("L/d");
          };
      case /* MediumDate */9 :
          return function (param) {
            return param.toFormat("cccc LLL d");
          };
      case /* LongDate */10 :
          return function (param) {
            return param.toFormat("cccc, LLLL d, yyyy");
          };
      case /* LongDateCompact */11 :
          return function (param) {
            return param.toFormat("ccc, LLL d, yyyy");
          };
      case /* LongMonthDayYear */12 :
          return function (param) {
            return param.toFormat("LLLL d, yyyy");
          };
      case /* LongMonthAndYear */13 :
          return function (param) {
            return param.toFormat("LLLL yyyy");
          };
      case /* Time */14 :
          return function (param) {
            return param.toFormat("h:mma");
          };
      case /* TimeWithTimezone */15 :
          return function (param) {
            return param.toFormat("h:mma ZZZZ");
          };
      case /* TimeNormalized */16 :
          return function (param) {
            return param.toFormat("hh:mm a");
          };
      case /* ShortDateTime */17 :
          return function (param) {
            return param.toFormat("ccc LLL d h:mma");
          };
      case /* ShortDateTimeWithTimezone */18 :
          return function (param) {
            return param.toFormat("ccc LLL d h:mma ZZZZ");
          };
      case /* CompactDateTime */19 :
          return function (param) {
            return param.toFormat("L/d h:mma");
          };
      case /* CompactDateTimeWithYear */20 :
          return function (param) {
            return param.toFormat("L/d/yy h:mma");
          };
      case /* USADateFormat */21 :
          return function (param) {
            return param.toFormat("L/d/yyyy");
          };
      case /* USADateFormatShortYear */22 :
          return function (param) {
            return param.toFormat("L/d/yy");
          };
      case /* LongMonth */23 :
          return function (param) {
            return param.toFormat("LLLL");
          };
      case /* LongYear */24 :
          return function (param) {
            return param.toFormat("yyyy");
          };
      
    }
  } else {
    var partial_arg = fmt._0;
    return function (param) {
      return param.toFormat(partial_arg);
    };
  }
}

function getDateWithoutTime(dt) {
  return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
}

var partial_arg = formatLuxonDate(/* Custom */{
      _0: "HH"
    });

function getHoursFromLuxon(param) {
  return Relude_Globals.$great$great(partial_arg, Caml_format.caml_int_of_string, param);
}

var partial_arg$1 = formatLuxonDate(/* Custom */{
      _0: "m"
    });

function getMinutesFromLuxon(param) {
  return Relude_Globals.$great$great(partial_arg$1, Caml_format.caml_int_of_string, param);
}

function setTimezone(dt) {
  return function (param) {
    return Relude_Globals.$great$great(CommonTypes_Timezone.toString, (function (__x) {
                  return dt.setZone(__x);
                }), param);
  };
}

function setTimezone$1(param, param$1) {
  return Relude_Globals.flip(setTimezone, param, param$1);
}

function setTimezoneIfNeeded(dt) {
  return function (param) {
    return Relude_Option.fold(dt, (function (__x) {
                  return setTimezone$1(__x, dt);
                }), param);
  };
}

function setTimezoneIfNeeded$1(param, param$1) {
  return Relude_Globals.flip(setTimezoneIfNeeded, param, param$1);
}

var Edge = {};

function toEnum(param) {
  switch (param) {
    case 0 :
        return /* Millisecond */0;
    case 1 :
        return /* Second */1;
    case 2 :
        return /* Minute */2;
    case 3 :
        return /* Hour */3;
    case 4 :
        return /* Day */4;
    case 5 :
        return /* Week */5;
    case 6 :
        return /* Month */6;
    case 7 :
        return /* Year */7;
    default:
      return ;
  }
}

function fromEnum(param) {
  return param;
}

var include = TypeUtils.TypeClasses.WithGenerateable({
      startingIndex: 0,
      fromEnum: fromEnum,
      toEnum: toEnum
    });

function toString(param) {
  switch (param) {
    case /* Millisecond */0 :
        return "millisecond";
    case /* Second */1 :
        return "second";
    case /* Minute */2 :
        return "minute";
    case /* Hour */3 :
        return "hour";
    case /* Day */4 :
        return "day";
    case /* Week */5 :
        return "week";
    case /* Month */6 :
        return "month";
    case /* Year */7 :
        return "year";
    
  }
}

function fromString$1(param) {
  return Relude_Globals.$great$great(Relude_String.toLowerCase, (function (param) {
                switch (param) {
                  case "d" :
                  case "day" :
                      return /* Day */4;
                  case "h" :
                  case "hour" :
                      return /* Hour */3;
                  case "m" :
                  case "min" :
                  case "minute" :
                      return /* Minute */2;
                  case "mo" :
                  case "month" :
                      return /* Month */6;
                  case "millisecond" :
                  case "ms" :
                  case "msec" :
                      return /* Millisecond */0;
                  case "s" :
                  case "sec" :
                  case "second" :
                      return /* Second */1;
                  case "w" :
                  case "week" :
                      return /* Week */5;
                  case "y" :
                  case "year" :
                      return /* Year */7;
                  default:
                    return ;
                }
              }), param);
}

function edgeToResolution(param) {
  if (param[0]) {
    switch (param[1]) {
      case /* Millisecond */0 :
          return Relude_Globals.id;
      case /* Second */1 :
          return function (prim) {
            return IndexJs$7(prim);
          };
      case /* Minute */2 :
          return function (prim) {
            return IndexJs$6(prim);
          };
      case /* Hour */3 :
          return function (prim) {
            return IndexJs$1(prim);
          };
      case /* Day */4 :
          return function (prim) {
            return IndexJs(prim);
          };
      case /* Week */5 :
          return function (prim) {
            return IndexJs$2(prim);
          };
      case /* Month */6 :
          return function (prim) {
            return IndexJs$4(prim);
          };
      case /* Year */7 :
          return function (prim) {
            return IndexJs$3(prim);
          };
      
    }
  } else {
    switch (param[1]) {
      case /* Millisecond */0 :
          return Relude_Globals.id;
      case /* Second */1 :
          return function (prim) {
            return IndexJs$13(prim);
          };
      case /* Minute */2 :
          return function (prim) {
            return IndexJs$12(prim);
          };
      case /* Hour */3 :
          return function (prim) {
            return IndexJs$8(prim);
          };
      case /* Day */4 :
          return function (prim) {
            return IndexJs$5(prim);
          };
      case /* Week */5 :
          return function (prim) {
            return IndexJs$9(prim);
          };
      case /* Month */6 :
          return function (prim) {
            return IndexJs$11(prim);
          };
      case /* Year */7 :
          return function (prim) {
            return IndexJs$10(prim);
          };
      
    }
  }
}

var Resolution_fromEnum = include.fromEnum;

var Resolution_toEnum = include.toEnum;

var Resolution_eq = include.eq;

var Resolution_compare = include.compare;

var Resolution_Ord = include.Ord;

var Resolution_compareWithConversion = include.compareWithConversion;

var Resolution_compareReversed = include.compareReversed;

var Resolution_OrdReversed = include.OrdReversed;

var Resolution_compareAsInt = include.compareAsInt;

var Resolution_min = include.min;

var Resolution_max = include.max;

var Resolution_lessThan = include.lessThan;

var Resolution_lt = include.lt;

var Resolution_lessThanOrEq = include.lessThanOrEq;

var Resolution_lte = include.lte;

var Resolution_greaterThan = include.greaterThan;

var Resolution_gt = include.gt;

var Resolution_greaterThanOrEq = include.greaterThanOrEq;

var Resolution_gte = include.gte;

var Resolution_clamp = include.clamp;

var Resolution_between = include.between;

var Resolution_OrdRingExtensions = include.OrdRingExtensions;

var Resolution_OrdNamed = include.OrdNamed;

var Resolution_OrdBy = include.OrdBy;

var Resolution_Set = include.$$Set;

var Resolution_SetWithNone = include.SetWithNone;

var Resolution_Map = include.$$Map;

var Resolution_list = include.list;

var Resolution_array = include.array;

var Resolution_set = include.set;

var Resolution_setWithNone = include.setWithNone;

var Resolution_cardinality = include.cardinality;

var Resolution_top = include.top;

var Resolution_bottom = include.bottom;

var Resolution_succ = include.succ;

var Resolution_pred = include.pred;

var Resolution = {
  Edge: Edge,
  fromEnum: Resolution_fromEnum,
  toEnum: Resolution_toEnum,
  eq: Resolution_eq,
  compare: Resolution_compare,
  Ord: Resolution_Ord,
  compareWithConversion: Resolution_compareWithConversion,
  compareReversed: Resolution_compareReversed,
  OrdReversed: Resolution_OrdReversed,
  compareAsInt: Resolution_compareAsInt,
  min: Resolution_min,
  max: Resolution_max,
  lessThan: Resolution_lessThan,
  lt: Resolution_lt,
  lessThanOrEq: Resolution_lessThanOrEq,
  lte: Resolution_lte,
  greaterThan: Resolution_greaterThan,
  gt: Resolution_gt,
  greaterThanOrEq: Resolution_greaterThanOrEq,
  gte: Resolution_gte,
  clamp: Resolution_clamp,
  between: Resolution_between,
  OrdRingExtensions: Resolution_OrdRingExtensions,
  OrdNamed: Resolution_OrdNamed,
  OrdBy: Resolution_OrdBy,
  $$Set: Resolution_Set,
  SetWithNone: Resolution_SetWithNone,
  $$Map: Resolution_Map,
  list: Resolution_list,
  array: Resolution_array,
  set: Resolution_set,
  setWithNone: Resolution_setWithNone,
  cardinality: Resolution_cardinality,
  top: Resolution_top,
  bottom: Resolution_bottom,
  succ: Resolution_succ,
  pred: Resolution_pred,
  toString: toString,
  fromString: fromString$1,
  edgeToResolution: edgeToResolution
};

function roundDateToResolution(edgeOpt, resolution, timezone) {
  var edge = edgeOpt !== undefined ? edgeOpt : /* End */1;
  var partial_arg = Relude_Option.fold(Relude_Globals.id, (function (param) {
          return Relude_Globals.$great$great((function (param) {
                        return Relude_Tuple.make2(edge, param);
                      }), edgeToResolution, param);
        }), resolution);
  var partial_arg$1 = Relude_Option.fold(Relude_Globals.id, (function (param) {
          return Relude_Globals.$$const((function (param) {
                        return Relude_Globals.$great$great((function (param) {
                                      return Relude_Globals.$great$great(getLuxonDate, (function (param) {
                                                    return setTimezoneIfNeeded$1(timezone, param);
                                                  }), param);
                                    }), (function (param) {
                                      return param.toJSDate();
                                    }), param);
                      }), param);
        }), timezone);
  return function (param) {
    return Relude_Globals.$great$great(partial_arg$1, partial_arg, param);
  };
}

function formatDate(format, timezone) {
  var partial_arg = formatLuxonDate(format);
  return function (param) {
    return Relude_Globals.$great$great((function (param) {
                  return Relude_Globals.$great$great(getLuxonDate, (function (date) {
                                if (timezone) {
                                  return date.setZone(Curry._1(CommonTypes_Timezone.toString, timezone._0));
                                } else {
                                  return date;
                                }
                              }), param);
                }), partial_arg, param);
  };
}

function getMediumDate(param) {
  return formatDate(/* MediumDate */9, param);
}

function getShortTime(param) {
  return formatDate(/* TimeWithTimezone */15, param);
}

function getShortDateShortTime(param) {
  return formatDate(/* ShortDateTimeWithTimezone */18, param);
}

function getTimeBetween(a, b) {
  return Curry._1(Relude_Float.abs, a.getTime() - b.getTime());
}

function secondsBetween(a, b) {
  return getTimeBetween(a, b) / 1000.0;
}

function minutesBetween(a, b) {
  return secondsBetween(a, b) / 60.0;
}

function hoursBetween(a, b) {
  return getTimeBetween(a, b) / 3600000.0;
}

function daysBetween(a, b) {
  var partial_arg = /* Day */4;
  var partial_arg$1 = /* Day */4;
  return hoursBetween(Curry._1(roundDateToResolution(undefined, partial_arg, undefined), a), Curry._1(roundDateToResolution(undefined, partial_arg$1, undefined), b)) / 24.0;
}

function getDuration(a, b) {
  return Luxon.Duration.fromMillis(getTimeBetween(a, b));
}

function getTimezoneOffsetInMinutes(timezone) {
  return function (param) {
    return Relude_Globals.$great$great((function (param) {
                  return Relude_Globals.$great$great(getLuxonDate, (function (param) {
                                return setTimezoneIfNeeded$1(timezone, param);
                              }), param);
                }), (function (prim) {
                  return prim.offset;
                }), param);
  };
}

function getDateRoundedToNthSecond(n) {
  var partial_arg = 1000.0 * Relude_Int.toFloat(n);
  var partial_arg$1 = function (param) {
    return partial_arg * param;
  };
  var partial_arg$2 = function (param) {
    return Relude_Globals.$great$great((function (param) {
                  return Relude_Globals.$great$great((function (param) {
                                return Relude_Globals.$great$great((function (prim) {
                                              return prim.getTime();
                                            }), (function (t) {
                                              return t / (1000.0 * Relude_Int.toFloat(n));
                                            }), param);
                              }), Relude_Float.floor, param);
                }), partial_arg$1, param);
  };
  return function (param) {
    return Relude_Globals.$great$great(partial_arg$2, (function (prim) {
                  return new Date(prim);
                }), param);
  };
}

function compare(timezone, resolution) {
  var partial_arg = function (eta) {
    return roundDateToResolution(undefined, resolution, timezone)(eta);
  };
  return Curry._1(Relude_String.compareWithConversion, (function (param) {
                return Relude_Globals.$great$great(partial_arg, (function (prim) {
                              return prim.toISOString();
                            }), param);
              }));
}

function eq(timezone, resolution, a, b) {
  return Curry._2(compare(timezone, resolution), a, b) === "equal_to";
}

function isGreaterThan(timezone, resolution, compareTo) {
  return function (param) {
    return Relude_Globals.$great$great((function (__x) {
                  return Curry._2(compare(timezone, resolution), __x, compareTo);
                }), (function (param) {
                  return "greater_than" === param;
                }), param);
  };
}

function isLessThan(timezone, resolution, compareTo) {
  return function (param) {
    return Relude_Globals.$great$great((function (__x) {
                  return Curry._2(compare(timezone, resolution), __x, compareTo);
                }), (function (param) {
                  return "less_than" === param;
                }), param);
  };
}

function isEqualTo(timezone, resolution, compareTo) {
  return function (param) {
    return Relude_Globals.$great$great((function (__x) {
                  return Curry._2(compare(timezone, resolution), __x, compareTo);
                }), (function (param) {
                  return "equal_to" === param;
                }), param);
  };
}

function isGreaterThanOrEqualTo(timezone, resolution, compareTo) {
  return function (param) {
    return Relude_Globals.$great$great((function (__x) {
                  return Curry._2(compare(timezone, resolution), __x, compareTo);
                }), (function (param) {
                  return "less_than" !== param;
                }), param);
  };
}

function isLessThanOrEqualTo(timezone, resolution, compareTo) {
  return function (param) {
    return Relude_Globals.$great$great((function (__x) {
                  return Curry._2(compare(timezone, resolution), __x, compareTo);
                }), (function (param) {
                  return "greater_than" !== param;
                }), param);
  };
}

function isBetween(timezone, resolution, startDatetime, endDatetime, datetime) {
  if (isGreaterThanOrEqualTo(timezone, resolution, startDatetime)(datetime)) {
    return isLessThanOrEqualTo(timezone, resolution, endDatetime)(datetime);
  } else {
    return false;
  }
}

function min(timezone, resolution, a, b) {
  if (isLessThan(timezone, resolution, b)(a)) {
    return a;
  } else {
    return b;
  }
}

function max(timezone, resolution, a, b) {
  if (isGreaterThan(timezone, resolution, b)(a)) {
    return a;
  } else {
    return b;
  }
}

function getDateWithAdjustedDuration(seconds, minutes, hours, days, months) {
  var partial_arg_1 = Duration$BsLuxon.from(days, hours, undefined, minutes, months, seconds, undefined, undefined, undefined);
  var partial_arg = function (param) {
    return param.plus(partial_arg_1);
  };
  var partial_arg$1 = function (param) {
    return Relude_Globals.$great$great(getLuxonDate, partial_arg, param);
  };
  return function (param) {
    return Relude_Globals.$great$great(partial_arg$1, (function (param) {
                  return param.toJSDate();
                }), param);
  };
}

var partial_arg$2 = formatLuxonDate(/* ISO */0);

function partial_arg$3(param) {
  return Relude_Globals.$great$great(getLuxonDate, partial_arg$2, param);
}

function getFilepathSafeTimestamp(param) {
  return Relude_Globals.$great$great(partial_arg$3, StringUtils.getNumbersOnly, param);
}

function getDateInForcedTimezone(timezone, dt) {
  var parts = dt.toObject();
  return set(parts, dt.setZone(Curry._1(CommonTypes_Timezone.toString, timezone)));
}

function getJsDateInForcedTimezone(timezone) {
  return function (param) {
    return Relude_Globals.$great$great((function (param) {
                  return Relude_Globals.$great$great(getLuxonDate, (function (param) {
                                return getDateInForcedTimezone(timezone, param);
                              }), param);
                }), (function (param) {
                  return param.toJSDate();
                }), param);
  };
}

var partial_arg$4 = Curry._1(CommonTypes_Timezone.toString, CommonTypes_Timezone.utc);

function partial_arg$5(param) {
  return param.setZone(partial_arg$4);
}

function partial_arg$6(param) {
  return Relude_Globals.$great$great(getLuxonDate, partial_arg$5, param);
}

function partial_arg$7(param) {
  return Relude_Globals.$great$great(partial_arg$6, (function (param) {
                return param.endOf("day");
              }), param);
}

function getISODateStringForEndOfDayInUTC(param) {
  return Relude_Globals.$great$great(partial_arg$7, (function (param) {
                return param.toISO();
              }), param);
}

var partial_arg$8 = Curry._1(CommonTypes_Timezone.toString, CommonTypes_Timezone.utc);

function partial_arg$9(param) {
  return param.setZone(partial_arg$8);
}

function partial_arg$10(param) {
  return Relude_Globals.$great$great(getLuxonDate, partial_arg$9, param);
}

function getISODateString(param) {
  return Relude_Globals.$great$great(partial_arg$10, (function (param) {
                return param.toISO();
              }), param);
}

function getNowInIO(param) {
  return Relude_IO.suspend(function (prim) {
              return new Date();
            });
}

function getNowInLogIO(param) {
  return LogIO.suspend(function (prim) {
              return new Date();
            });
}

var partial_arg$11 = formatLuxonDate(/* Custom */{
      _0: "EEEE"
    });

function getDayOfTheWeek(param) {
  return Relude_Globals.$great$great(partial_arg$11, (function (param) {
                switch (param) {
                  case "Friday" :
                      return /* Friday */5;
                  case "Monday" :
                      return /* Monday */1;
                  case "Saturday" :
                      return /* Saturday */6;
                  case "Sunday" :
                      return /* Sunday */0;
                  case "Thursday" :
                      return /* Thursday */4;
                  case "Tuesday" :
                      return /* Tuesday */2;
                  case "Wednesday" :
                      return /* Wednesday */3;
                  default:
                    return /* Sunday */0;
                }
              }), param);
}

function monthStartsOn(param) {
  return Relude_Globals.$great$great((function (param) {
                return param.startOf("month");
              }), getDayOfTheWeek, param);
}

function monthEndsOn(param) {
  return Relude_Globals.$great$great((function (param) {
                return param.endOf("month");
              }), getDayOfTheWeek, param);
}

var partial_arg$12 = formatLuxonDate(/* Custom */{
      _0: "L"
    });

function getMonthFromLuxon(param) {
  return Relude_Globals.$great$great(partial_arg$12, Caml_format.caml_int_of_string, param);
}

var getMonthNameFromLuxon = formatLuxonDate(/* Custom */{
      _0: "LLLL"
    });

var partial_arg$13 = formatLuxonDate(/* Custom */{
      _0: "y"
    });

function getYearFromLuxon(param) {
  return Relude_Globals.$great$great(partial_arg$13, Caml_format.caml_int_of_string, param);
}

var partial_arg$14 = formatLuxonDate(/* Custom */{
      _0: "d"
    });

function getDayFromLuxon(param) {
  return Relude_Globals.$great$great(partial_arg$14, Caml_format.caml_int_of_string, param);
}

function getDaysInMonth(param) {
  return Relude_Globals.$great$great((function (param) {
                return param.endOf("month");
              }), getDayFromLuxon, param);
}

function toInt(param) {
  return param;
}

function fromInt(x) {
  if (x < 0) {
    return /* January */0;
  } else if (x > 10 || x < 0) {
    return /* December */11;
  } else {
    return x;
  }
}

function next(month) {
  return fromInt(month + 1 | 0);
}

function prev(month) {
  return fromInt(month - 1 | 0);
}

var compare$1 = Curry._1(Relude_Int.compareWithConversion, toInt);

var eq$1 = Curry._1(Relude_Int.eqWithConversion, toInt);

function fromLuxon(luxonDate) {
  return fromInt(getMonthFromLuxon(luxonDate) - 1 | 0);
}

var Month = {
  toInt: toInt,
  bottom: /* January */0,
  top: /* December */11,
  fromInt: fromInt,
  next: next,
  prev: prev,
  compare: compare$1,
  eq: eq$1,
  fromLuxon: fromLuxon
};

function toString$1(param) {
  return Relude_Int.toString(param.year) + ("-" + (StringUtils.leftPad("0", 2, Relude_Int.toString(param.month + 1 | 0)) + ("-" + StringUtils.leftPad("0", 2, Relude_Int.toString(param.day)))));
}

var compare$2 = Curry._1(Relude_String.compareWithConversion, toString$1);

var eq$2 = Curry._1(Relude_String.eqWithConversion, toString$1);

var Ord = {
  compare: compare$2,
  eq: eq$2
};

var $$Map = Relude_Map.WithOrd({
      eq: eq$2,
      compare: compare$2
    });

var $$Set = Relude_Set.WithOrd({
      eq: eq$2,
      compare: compare$2
    });

var CalendarDay = {
  toString: toString$1,
  Ord: Ord,
  $$Map: $$Map,
  $$Set: $$Set
};

function getDurationPart(amount, suffix) {
  if (Relude_Int.eq(0, amount)) {
    return ;
  } else {
    return Relude_Int.toString(amount) + (" " + (suffix + (
                Curry._2(Relude_Int.OrdNamed.greaterThan, 1, amount) ? "s" : ""
              )));
  }
}

function getFormattedDuration(startDate, endDate) {
  if (isLessThanOrEqualTo(undefined, undefined, endDate)(startDate)) {
    var duration = Luxon.Duration.fromMillis(getTimeBetween(startDate, endDate));
    return Relude_Option.reject(StringUtils.isEmpty)(Relude_Option.pure(Curry._3(Relude_Array.foldLeft, (function (prim, prim$1) {
                          return prim + prim$1;
                        }), "", Relude_Array.intersperse(", ", Relude_Array.mapOption(Relude_Globals.id, [
                                getDurationPart(getIntervalPart("days", duration), "day"),
                                getDurationPart(getIntervalPart("hours", duration) % 24, "hr"),
                                getDurationPart(getIntervalPart("minutes", duration) % 60, "min"),
                                getDurationPart(getIntervalPart("seconds", duration) % 60, "sec")
                              ])))));
  }
  
}

var partial_arg$15 = Curry._1(Relude_String.eqWithConversion, (function (prim) {
        return prim.toISOString();
      }));

function optionalJsDateEq(param, param$1) {
  return Relude_Option.eqBy(partial_arg$15, param, param$1);
}

function optionalJsDateNotEq(a, b) {
  return Relude_Globals.inverse(optionalJsDateEq(a, b));
}

function diff(dateA, dateB) {
  return dateA.getTime() - dateB.getTime();
}

function seconds(i) {
  return Relude_Int.toFloat(Math.imul(i, 1000));
}

function minutes(i) {
  return Relude_Int.toFloat(Math.imul(i, 60000));
}

function hours(i) {
  return Relude_Int.toFloat(Math.imul(i, 3600000));
}

function days(i) {
  return Relude_Int.toFloat(Math.imul(i, 86400000));
}

function truncate(coeff, t) {
  return FloatSafe.toFloat(FloatSafe.$star$dot$dot(FloatSafe.roundDown(0, FloatSafe.$slash$dot$dot(new BigJs.Big(t), FloatSafe.fromInt(coeff))), FloatSafe.fromInt(coeff)));
}

function truncateToSecond(param) {
  return truncate(1000, param);
}

function truncateToMinute(param) {
  return truncate(60000, param);
}

function truncateToHour(param) {
  return truncate(3600000, param);
}

function truncateToDay(param) {
  return truncate(86400000, param);
}

var include$1 = Relude_Extensions_Ord.OrdExtensions(Relude_Float.Ord);

var include$2 = Relude_Extensions_Ord.OrdInfix(Relude_Float.Ord);

var Timespan_Ord = {
  compare: Relude_Float.Ord.compare,
  eq: Relude_Float.Ord.eq
};

var Timespan_compareWithConversion = include$1.compareWithConversion;

var Timespan_compareReversed = include$1.compareReversed;

var Timespan_OrdReversed = include$1.OrdReversed;

var Timespan_compareAsInt = include$1.compareAsInt;

var Timespan_min = include$1.min;

var Timespan_max = include$1.max;

var Timespan_lessThan = include$1.lessThan;

var Timespan_lt = include$1.lt;

var Timespan_lessThanOrEq = include$1.lessThanOrEq;

var Timespan_lte = include$1.lte;

var Timespan_greaterThan = include$1.greaterThan;

var Timespan_gt = include$1.gt;

var Timespan_greaterThanOrEq = include$1.greaterThanOrEq;

var Timespan_gte = include$1.gte;

var Timespan_clamp = include$1.clamp;

var Timespan_between = include$1.between;

var Timespan_OrdRingExtensions = include$1.OrdRingExtensions;

var Timespan_OrdNamed = include$1.OrdNamed;

var Timespan_OrdBy = include$1.OrdBy;

var Timespan_OrdExtensions = include$2.OrdExtensions;

var Timespan_$pipe$less$pipe = include$2.$pipe$less$pipe;

var Timespan_$pipe$less$eq$pipe = include$2.$pipe$less$eq$pipe;

var Timespan_$pipe$great$pipe = include$2.$pipe$great$pipe;

var Timespan_$pipe$great$eq$pipe = include$2.$pipe$great$eq$pipe;

var Timespan = {
  make: Relude_Int.toFloat,
  diff: diff,
  millis: Relude_Int.toFloat,
  seconds: seconds,
  minutes: minutes,
  hours: hours,
  days: days,
  truncateToSecond: truncateToSecond,
  truncateToMinute: truncateToMinute,
  truncateToHour: truncateToHour,
  truncateToDay: truncateToDay,
  Ord: Timespan_Ord,
  compareWithConversion: Timespan_compareWithConversion,
  compareReversed: Timespan_compareReversed,
  OrdReversed: Timespan_OrdReversed,
  compareAsInt: Timespan_compareAsInt,
  min: Timespan_min,
  max: Timespan_max,
  lessThan: Timespan_lessThan,
  lt: Timespan_lt,
  lessThanOrEq: Timespan_lessThanOrEq,
  lte: Timespan_lte,
  greaterThan: Timespan_greaterThan,
  gt: Timespan_gt,
  greaterThanOrEq: Timespan_greaterThanOrEq,
  gte: Timespan_gte,
  clamp: Timespan_clamp,
  between: Timespan_between,
  OrdRingExtensions: Timespan_OrdRingExtensions,
  OrdNamed: Timespan_OrdNamed,
  OrdBy: Timespan_OrdBy,
  OrdExtensions: Timespan_OrdExtensions,
  $pipe$less$pipe: Timespan_$pipe$less$pipe,
  $pipe$less$eq$pipe: Timespan_$pipe$less$eq$pipe,
  $pipe$great$pipe: Timespan_$pipe$great$pipe,
  $pipe$great$eq$pipe: Timespan_$pipe$great$eq$pipe
};

var millisecondsPerHour = 3600000.0;

var hoursPerDay = 24.0;

var isBefore = isLessThan;

var isAfter = isGreaterThan;

exports.Luxon = Luxon$1;
exports.cloneJsDateToPreventMutation = cloneJsDateToPreventMutation;
exports.fromString = fromString;
exports.getLuxonDate = getLuxonDate;
exports.getLuxonNow = getLuxonNow;
exports.getLocalTimezone = getLocalTimezone;
exports.formatLuxonDate = formatLuxonDate;
exports.getDateWithoutTime = getDateWithoutTime;
exports.getHoursFromLuxon = getHoursFromLuxon;
exports.getMinutesFromLuxon = getMinutesFromLuxon;
exports.setTimezone = setTimezone$1;
exports.setTimezoneIfNeeded = setTimezoneIfNeeded$1;
exports.Resolution = Resolution;
exports.roundDateToResolution = roundDateToResolution;
exports.formatDate = formatDate;
exports.getMediumDate = getMediumDate;
exports.getShortTime = getShortTime;
exports.getShortDateShortTime = getShortDateShortTime;
exports.getTimeBetween = getTimeBetween;
exports.secondsBetween = secondsBetween;
exports.minutesBetween = minutesBetween;
exports.millisecondsPerHour = millisecondsPerHour;
exports.hoursBetween = hoursBetween;
exports.hoursPerDay = hoursPerDay;
exports.daysBetween = daysBetween;
exports.getDuration = getDuration;
exports.getTimezoneOffsetInMinutes = getTimezoneOffsetInMinutes;
exports.getDateRoundedToNthSecond = getDateRoundedToNthSecond;
exports.compare = compare;
exports.eq = eq;
exports.isGreaterThan = isGreaterThan;
exports.isLessThan = isLessThan;
exports.isEqualTo = isEqualTo;
exports.isGreaterThanOrEqualTo = isGreaterThanOrEqualTo;
exports.isLessThanOrEqualTo = isLessThanOrEqualTo;
exports.isBefore = isBefore;
exports.isAfter = isAfter;
exports.isBetween = isBetween;
exports.min = min;
exports.max = max;
exports.getDateWithAdjustedDuration = getDateWithAdjustedDuration;
exports.getFilepathSafeTimestamp = getFilepathSafeTimestamp;
exports.getDateInForcedTimezone = getDateInForcedTimezone;
exports.getJsDateInForcedTimezone = getJsDateInForcedTimezone;
exports.getISODateStringForEndOfDayInUTC = getISODateStringForEndOfDayInUTC;
exports.getISODateString = getISODateString;
exports.getNowInIO = getNowInIO;
exports.getNowInLogIO = getNowInLogIO;
exports.getDayOfTheWeek = getDayOfTheWeek;
exports.monthStartsOn = monthStartsOn;
exports.monthEndsOn = monthEndsOn;
exports.getMonthFromLuxon = getMonthFromLuxon;
exports.getMonthNameFromLuxon = getMonthNameFromLuxon;
exports.getYearFromLuxon = getYearFromLuxon;
exports.getDayFromLuxon = getDayFromLuxon;
exports.getDaysInMonth = getDaysInMonth;
exports.Month = Month;
exports.CalendarDay = CalendarDay;
exports.getFormattedDuration = getFormattedDuration;
exports.optionalJsDateEq = optionalJsDateEq;
exports.optionalJsDateNotEq = optionalJsDateNotEq;
exports.Timespan = Timespan;
/* partial_arg Not a pure module */
